import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import imagenPredeterminada from "../../images/casa_arte.jpg";

const ConfiguracionSitioContext = createContext(null);

export const PERSONALIZACION_PREDETERMINADA = {
  nombre_tienda: "Casa Arte",
  lema: "Arte que transforma tus espacios",
  descripcion_footer: "Obras y piezas con personalidad para transformar tus espacios y acercar el arte a tu vida cotidiana.",
  instagram_url: "https://www.instagram.com/casa_arte.lg?igsh=cjB4ZmxiN3h3NWY2",
  whatsapp_numero: "59899075944",
  whatsapp_mensaje: "Hola, me gustaria mas informacion sobre las obras de Casa Arte.",
  mostrar_whatsapp: "si",
  dashboard_titulo: "Tienda de arte",
  dashboard_descripcion: "Administra obras, materiales, piezas decorativas y colecciones desde un panel claro. Controla precios, stock, imagenes y disponibilidad para mantener la tienda lista para tus clientes.",
  fuente: "moderna",
  bordes: "suaves",
  tamano_texto: "normal",
  logo_tamano: "normal",
  tienda_principal: "#111111",
  tienda_acento: "#b45309",
  tienda_fondo: "#ffffff",
  tienda_texto: "#1c1917",
  tienda_cabecera: "#ffffff",
  tienda_footer: "#0c0a09",
  tienda_tarjeta: "#ffffff",
  tienda_borde: "#e7e5e4",
  admin_principal: "#111111",
  admin_acento: "#b45309",
  admin_fondo: "#fafaf9",
  admin_texto: "#1c1917",
  admin_cabecera: "#ffffff",
  admin_tarjeta: "#ffffff",
  admin_borde: "#e7e5e4",
};

export const ConfiguracionSitioProvider = ({ children }) => {
  const [configuracion, setConfiguracion] = useState({ logo_url: null, dashboard_imagen_url: null, personalizacion: {} });

  useEffect(() => {
    const controller = new AbortController();
    axios.get(`${process.env.REACT_APP_API_URL}/configuracion-sitio`, { signal: controller.signal })
      .then(({ data }) => setConfiguracion(data))
      .catch((error) => {
        if (!axios.isCancel(error)) console.error("No se pudo cargar la configuracion", error);
      });
    return () => controller.abort();
  }, []);

  const resolverImagen = (url) => url ? `${process.env.REACT_APP_BACKEND_URL}${url}` : imagenPredeterminada;

  const actualizarImagen = async (tipo, imagen, token) => {
    const formData = new FormData();
    formData.append("tipo", tipo);
    formData.append("imagen", imagen);
    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/admin/configuracion-sitio/imagen`, formData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setConfiguracion(data);
    return data;
  };

  const actualizarPersonalizacion = async (personalizacion, token) => {
    const { data } = await axios.put(
      `${process.env.REACT_APP_API_URL}/admin/configuracion-sitio`,
      personalizacion,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setConfiguracion(data);
    return data;
  };

  const personalizacion = { ...PERSONALIZACION_PREDETERMINADA, ...(configuracion.personalizacion || {}) };

  return (
    <ConfiguracionSitioContext.Provider value={{
      logoUrl: resolverImagen(configuracion.logo_url),
      dashboardImagenUrl: resolverImagen(configuracion.dashboard_imagen_url),
      imagenPredeterminada,
      actualizarImagen,
      personalizacion,
      actualizarPersonalizacion,
    }}>
      {children}
    </ConfiguracionSitioContext.Provider>
  );
};

export const useConfiguracionSitio = () => useContext(ConfiguracionSitioContext);
